import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { Box, Link } from '@mui/material';
import type { ReactNode } from 'react';

/** A cell's value with a "Show document" link under it. Without `onShowDocument`, just the value. */
export function ShowDocumentCell({
  children,
  onShowDocument,
}: {
  children: ReactNode;
  onShowDocument?: () => void;
}) {
  if (!onShowDocument) return <>{children}</>;

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}
    >
      <Box sx={{ lineHeight: 1.4 }}>{children}</Box>
      <Link
        component="button"
        type="button"
        variant="caption"
        underline="hover"
        color="primary"
        sx={{
          alignSelf: 'flex-start',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          lineHeight: 1.4,
        }}
        onClick={(event) => {
          event.stopPropagation();
          onShowDocument();
        }}
      >
        <DescriptionOutlinedIcon sx={{ fontSize: 14 }} />
        Show document
      </Link>
    </Box>
  );
}
